"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortFields = void 0;
var HEAD_ORDER = [
    'email',
    'firstName',
    'lastName',
    'zip',
    'city',
    'addressNumber',
    'address',
];
var TAIL_ORDER = ['birthdayDate', 'dateOfBirth', 'dayOfBirth', 'phone'];
var norm = function (s) { return (s !== null && s !== void 0 ? s : '').trim(); };
var getKey = function (f) { return norm(f.type) || norm(f.name); };
function sortFields(fields) {
    if (!Array.isArray(fields) || fields.length === 0)
        return fields !== null && fields !== void 0 ? fields : [];
    var headPicked = new Set();
    var head = [];
    var _loop_1 = function (wanted) {
        fields.forEach(function (f, idx) {
            if (!headPicked.has(idx) && getKey(f) === wanted) {
                head.push(f);
                headPicked.add(idx);
            }
        });
    };
    for (var _i = 0, HEAD_ORDER_1 = HEAD_ORDER; _i < HEAD_ORDER_1.length; _i++) {
        var wanted = HEAD_ORDER_1[_i];
        _loop_1(wanted);
    }
    var tailPicked = new Set();
    var tail = [];
    var _loop_2 = function (wanted) {
        fields.forEach(function (f, idx) {
            if (!headPicked.has(idx) &&
                !tailPicked.has(idx) &&
                getKey(f) === wanted) {
                tail.push(f);
                tailPicked.add(idx);
            }
        });
    };
    for (var _a = 0, TAIL_ORDER_1 = TAIL_ORDER; _a < TAIL_ORDER_1.length; _a++) {
        var wanted = TAIL_ORDER_1[_a];
        _loop_2(wanted);
    }
    var middle = [];
    fields.forEach(function (f, idx) {
        if (!headPicked.has(idx) && !tailPicked.has(idx)) {
            middle.push(f);
        }
    });
    return __spreadArray(__spreadArray(__spreadArray([], head, true), middle, true), tail, true);
}
exports.sortFields = sortFields;
